import './spaceBar.css';

export default function SpaceBar({width, offset, thick, color, center}) {

    const isThick = thick ? '1.3rem' : '0.6rem';

    return (
        <div className="spacer-bar"
            style={{
                width: width,
                height: isThick,
                background: color,
                transform: `translateX(${offset})`,
                margin: center 
            }}
        />
    )
}